<template>
  <transition name="fade-in" appear>
    <div
      style="z-index: 99999"
      v-show="mostrarModal"
      class="modal-main fade-in"
    >
      <div class="modal-content">
        <div class="modal-header">
          <span
            class="close"
            @click="fecharModal()"
            style="position: absolute; top: 10px; right: 10px"
          >
            &times;
          </span>
          <div class="header-content">
            <h2>Meus Contratos e Planos</h2>
          </div>
        </div>
        <div class="modal-body">
          <!-- Check if contracts list is empty -->
          <template v-if="contracts.length === 0">
            <p>Nenhuma placa no padrão antigo encontrada nos seus contratos!</p>
          </template>
          <!-- Display table if contracts list is not empty -->
          <template v-else>
            <div class="table-container">
              <table class="styled-table">
                <thead>
                  <tr>
                    <th>Contrato</th>
                    <th>Plano</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Example rows (replace with your data) -->
                  <tr v-for="(contract, index) in contracts" :key="index">
                    <td>{{ contract.contractId }}</td>
                    <td>{{ contract.name }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'contract-vehicles',
                          params: { contractId: contract.contractId },
                        }"
                      >
                        <button class="stilizedButton" v-if="!isMobile">
                          Veículos Cadastrados
                          <img
                            class="redirect-button"
                            src="../assets/img/icons/RedirectButton.svg"
                          />
                        </button>
                        <button class="stilizedButton" v-if="isMobile">
                          <img
                            class="redirect-button"
                            src="../assets/img/icons/RedirectButton.svg"
                          />
                        </button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button class="close-button" @click="fecharModal()">Fechar</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import auth from "../services/auth.js";
import vehicle from "../services/vehicles.js";
export default {
  props: {
    plateToConvert: undefined,
    // contracts: [],
  },
  data() {
    return {
      contracts: [],
      isMobile: undefined,

      mostrarModal: true,
    };
  },

  computed: {
    currentUser() {
      return auth.currentUser;
    },
  },

  mounted() {
    this.listContracts();
    if (window.innerWidth <= 769) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    // evento disparado toda vez que a tela muda de tamanho
    window.addEventListener("resize", () =>
      window.innerWidth <= 769
        ? (this.isMobile = true)
        : (this.isMobile = false)
    );
  },

  methods: {
    fecharModal() {
      if (!this.isMobile) {
        const modal = document.querySelector(".modal-main");
        modal.classList.add("fade-out");
        modal.classList.remove("fade-in");

        modal.addEventListener("animationend", () => {
          this.mostrarModal = false;
          this.$emit("close");
        });
      } else {
        this.mostrarModal = false;
        this.$emit("close");
      }
    },

    listContracts() {
      vehicle.getContractUserList(this.currentUser.moveMaisId).then((res) => {
        this.contracts = res;
      });
    },
  },
};
</script>

<style scoped>
.table-container {
  max-height: 400px;
  overflow: auto;
  overflow-x: hidden;
}
.close-button {
  display: flex;
  width: 101px;
  height: 38px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 40px;
  color: var(--primary-light, #5d3b81);
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: white;
  border: none;
  margin-left: 508px;
}
.styled-table {
  width: 820px;
  border-collapse: collapse;
  margin: auto;
  margin-left: 23px;
  margin-top: -9px;
}

.styled-table th,
.styled-table td {
  padding: 15px;
  text-align: left;
  margin-right: 5px;
}

.styled-table th:not(:last-child),
.styled-table td:not(:last-child) {
  margin-right: 5px;
}
.styled-table th {
  color: black;
}

.modal-main {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  overflow-x: hidden;
}

.modal-content {
  background-color: #fff;
  width: 730px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  border-radius: 10px;
  overflow-x: hidden;
}

.modal-header {
  background: #613a7d;
  color: white;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  border-radius: 4px;
}

.modal-header h2 {
  margin: 0;
}

h2 {
  color: #fff;
  font-family: Open Sans;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}

.header-content {
  margin-left: 26px;
}

.close {
  font-size: 24px;
  cursor: pointer;
  width: 24px;
  height: 24px;
}
.modal-body {
  padding: 0px;
  overflow-x: hidden;
}

.modal-footer {
  padding: 13px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.stilizedButton {
  display: inline-flex;
  padding: 5px 10.29px 7px 19px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 13.71px;
  border-radius: 20px;
  border: 0.5px solid #039;
  background: #d7e6fb;
}
.fade-in {
  animation: fadeIn 0.4s ease;
}

.redirect-button {
  margin-top: 2px;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fade-out {
  animation: fadeOut 0.2s ease;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@media (max-width: 1366px) {
  .modal-main {
    margin-top: 20px;
  }

  .styled-table th,
  .styled-table td {
    padding: 10px;
  }
}

@media (max-width: 800px) {
  .modal-content {
    width: 650px;
  }
  .styled-table {
    width: 100%;
    border-collapse: collapse;
    margin: auto;
    margin-top: -9px;
  }

  .styled-table th,
  .styled-table td {
    padding: 10px;
  }
}

@media (max-width: 600px) {
  .modal-content {
    width: 650px;
  }
  .styled-table {
    width: 100%;
    border-collapse: collapse;
    margin: auto;
    margin-top: -9px;
  }

  .styled-table th,
  .styled-table td {
    padding: 10px;
  }

  .close-button {
    margin-left: 10px;
  }
}

@media (max-width: 500px) {
  .modal-main {
    margin-top: 20px;
  }
  .modal-content {
    width: 412px;
  }

  .styled-table {
    width: 100%;
    border-collapse: collapse;
    margin: auto;
    margin-top: -9px;
  }

  .styled-table th,
  .styled-table td {
    padding: 10px;
  }

  .close-button {
    margin-left: 1px;
  }
}

@media (max-width: 400px) {
  .modal-main {
    margin-top: -22px;
  }
  .modal-content {
    width: 412px;
  }

  .styled-table {
    width: 100%;
    border-collapse: collapse;
    margin: auto;
    margin-top: -9px;
  }

  .styled-table th,
  .styled-table td {
    padding: 10px;
  }

  .close-button {
    margin-left: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// modal-my-contracts.vue?42febb30